import type { ZudokuConfig } from "zudoku";

const isProduction = process.env.ZUDOKU_PUBLIC_NODE_ENV === "production";

const HIDDEN_API_SPECS_IN_PRODUCTION = [
  "catalog/webhooks-api",
  "catalog/app-store",
  "catalog/gab-private-api",
  "catalog/revenue-core-api"
];

const allApiSpecs: ZudokuConfig["apis"] = [
  {
    path: "catalog/plc-api",
    type: "file" as const,
    input: [
      "./packages/plc-openapi-spec/v2/plce-api.oas.yaml",
      "./packages/plc-openapi-spec/v1/plce-api-v1.oas.yaml",
    ],
    categories: [{ label: "Public Service Platform", tags: ["Permitting & Licensing"] }],
  },
  {
    path: "catalog/bnp-api",
    type: "file" as const,
    input: ["./packages/bnp-openapi-spec/bnp-public-api.yaml"],
    categories: [{ label: "Public Service Platform", tags: ["Budgeting & Performance"] }],
  },
  {
    path: "catalog/eam-api",
    type: "file" as const,
    input: ["./packages/eam-openapi-spec/v1/eam-api.yaml"],
    categories: [
      {
        label: "Public Service Platform",
        tags: ["Enterprise Asset Management"],
      },
    ],
  },
  {
    path: "catalog/webhooks-api",
    type: "file" as const,
    input: ["./packages/webhooks-openapi-spec/v2/webhooks.oas.yaml"],
    categories: [{ label: "Developer APIs", tags: ["Webhooks"] }],
  },

  {
    path: "catalog/app-store",
    type: "file" as const,
    input: ["./packages/appstore-openapi-spec/v2/appstore.oas.yaml"],
    categories: [{ label: "Developer APIs", tags: ["App Store"] }],
  },
  {
    path: "catalog/pro-api",
    type: "file" as const,
    input: [
      "./packages/pro-openapi-spec/v2/pro-combined-v2.yaml",
      "./packages/pro-openapi-spec/v1/pro-combined-v1.yaml",
    ],
    categories: [
      {
        label: "Public Service Platform",
        tags: ["Procurement & Contract Management"],
      },
    ],
  },
  {
    path: "catalog/pro-purchase-order-api",
    type: "file" as const,
    input: ["./packages/pro-purchase-order-openapi-spec/pro-purchase-order-api.yaml"],
    categories: [
      {
        label: "Public Service Platform",
        tags: ["Procurement & Contract Management"],
      },
    ],
  },
  {
    path: "catalog/pro-receipt-api",
    type: "file" as const,
    input: ["./packages/pro-receipt-openapi-spec/pro-receipt-api.yaml"],
    categories: [
      {
        label: "Public Service Platform",
        tags: ["Procurement & Contract Management"],
      },
    ],
  },
  {
    path: "catalog/opendata-public-api",
    type: "file" as const,
    input: ["./packages/opendata-openapi-spec/opendata-public-api.yaml"],
    categories: [
      {
        label: "Public Service Platform",
        tags: ["Open Data"],
      },
    ],
  },
  {
    path: "catalog/gab-private-api",
    type: "file" as const,
    input: ["./packages/gab-openapi-spec/gab-api.yaml"],
    categories: [
      {
        label: "Public Service Platform",
        tags: ["Government Application Builder"],
      },
    ],
  },
  {
    path: "catalog/revenue-core-api",
    type: "file" as const,
    input: ["./packages/revenue-openapi-spec/revenue-api.yaml"],
    categories: [
      {
        label: "Public Service Platform",
        tags: ["Utility Billing"],
      },
    ],
  },
  {
    path: "catalog/vm-api",
    type: "file" as const,
    input: ["./packages/vm-openapi-spec/v1/vm-public-api.yaml"],
    categories: [
      {
        label: "Public Service Platform",
        tags: ["Vendor Management"],
      },
    ],
  },
];

// Filter API specs based on environment
export const apis: ZudokuConfig["apis"] = isProduction
  ? allApiSpecs.filter((spec) =>
      spec.path ? !HIDDEN_API_SPECS_IN_PRODUCTION.includes(spec.path) : true
    )
  : allApiSpecs;
